import React, { PureComponent } from 'react';
import { FormField } from 'ui/form/form-field';
import { isValue } from 'ui/form/utils';

export function formData(target, key, descriptor) {
  target.wantsFormData = true;
  return descriptor;
}

export function wantsFormData(child: React.ReactChild): boolean {
  return child && child.type && child.type.wantsFormData;
}

// Components
interface ChildFieldProps {
  child: React.ReactChild;
  name: string;
  value: any;
  childRef: (name: string, ref: FormField) => void;
  onChange: (name: string, value: any) => any;
}

export default class ChildField extends PureComponent<ChildFieldProps> {
  handleChange = value => {
    const { onChange, name } = this.props;
    
    if (onChange) onChange(name, value);
  };

  handleRef = ref => {
    const { childRef, name } = this.props;
    
    if (childRef) childRef(name, ref);
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const { child, value, formData, noValidation, childRef, onChange, name, ...rest } = this.props;
    return (
      <child.type
        {...child.props}
        {...rest}
        label={child.props.label || name}
        value={isValue(value) ? value : child.props.default}
        onChange={this.handleChange}
        noValidation={noValidation || child.props.noValidation}
        ref={this.handleRef}
        formData={wantsFormData(child) && formData[name]}
      />
    );
  }
}
